import { createParser, parseAsString } from 'nuqs';
import { useQueryStateFixed } from '@Utils/nuqs-fix';
import type { FlowListSortField } from '../types';

const VALID_SORT_FIELDS: FlowListSortField[] = [
  'flowFilter',
  'startedAt',
  'lastActivityAt',
  'activeStageFilter',
  'category',
];

const parseAsSortField = createParser<FlowListSortField>({
  parse: (v) =>
    VALID_SORT_FIELDS.includes(v as FlowListSortField)
      ? (v as FlowListSortField)
      : null,
  serialize: (v) => v,
  eq: (a, b) => a === b,
}).withDefault('flowFilter');

export function useFlowListSearchParams() {
  const [flowFilter, setFlowFilter] = useQueryStateFixed<string>(
    'flowFilter',
    parseAsString,
  );
  const [activeStageFilter, setActiveStageFilter] = useQueryStateFixed<string>(
    'activeStageFilter',
    parseAsString,
  );
  const [categoryFilter, setCategoryFilter] = useQueryStateFixed<string>(
    'categoryFilter',
    parseAsString,
  );
  const [sortBy, setSortBy] = useQueryStateFixed<
    FlowListSortField,
    FlowListSortField
  >('sortBy', parseAsSortField);

  return {
    flowFilter,
    setFlowFilter,
    activeStageFilter,
    setActiveStageFilter,
    categoryFilter,
    setCategoryFilter,
    sortBy,
    setSortBy,
  };
}
